import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {OptionalLinkComponent} from "./optional-link.component";



@NgModule({
  declarations: [
    OptionalLinkComponent
  ],
  exports: [
    OptionalLinkComponent
  ],
  imports: [
    CommonModule
  ]
})
export class OptionalLinkModule { }
